import {
  createListAllQuery,
  Event,
  listEvents,
  ListEventsQueryVariables,
} from '@akin-home/amplify';
import { objectToQueryParams } from '@akin-home/objects';
import { createMockableFunction } from '@akin-home/testing';
import { API } from 'aws-amplify';
import { listMockEventsAsync } from './mocks';

export const listAllEventsQuery = createMockableFunction({
  main: createListAllQuery<Event, ListEventsQueryVariables>(
    listEvents,
    'listEvents'
  ),
  mock: listMockEventsAsync,
});

export const listAllEventsByHabitatQuery = async (
  habitatID: string,
  filters?: { from?: string; to?: string; title?: string }
) => {
  const query_params = objectToQueryParams(filters);

  const { data } = await API.get(
    'CalendarAPI',
    `/events/habitat/${habitatID}?${query_params}`,
    {}
  );

  return data;
};

export const getEventQuery = async (id: string) => {
  return (await API.get('CalendarAPI', `/events/${id}`.replace('#', '%23'), {}))
    .data;
};
